module.exports = new __parcel__URL__("demo.6ab0a077.mp3").toString();